import { Identifiers, SectionsKey } from "~/constants/enum";

const PageStruct = {
    id: 'sign-up',
    useLayout: true,
    children: [{ id: SectionsKey.SignUp, order: 1 },
    { id: SectionsKey.BenefitsSection, order: 2, identifier: Identifiers.BenefitsSection },
    { id: SectionsKey.FollowUs, order: 3, identifier: Identifiers.FollowUs }]
};

export default PageStruct;
